import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { NavItemBadge } from './NavItemBadge';
import { FavoriteStar } from './FavoriteStar';
import { useProjectContext } from '../../contexts/ProjectContextProvider';

// Statusmärken (mognadsgrad) visas inte längre i menyn (Mikael 2026-10-26).
// Övriga märken, t.ex. AI, visas som förut.
const STATUS_BADGES = new Set(['ALFA', 'BETA', 'MVP', 'V1', 'S1', 'WIP', 'DEV', 'NY']);
function isStatusBadge(label) {
  return label && STATUS_BADGES.has(String(label).toUpperCase());
}

function resolveIcon(name) {
  if (!name) return LucideIcons.Square;
  return LucideIcons[name] || LucideIcons.Square;
}

function formatCount(n) {
  if (!Number.isFinite(n)) return '';
  if (n > 99) return '99+';
  return String(n);
}

export function NavItem({ module, isFavorite, onToggleFavorite, showStar, unreadCount = 0 }) {
  const Icon = useMemo(() => resolveIcon(module.iconName), [module.iconName]);
  const showCount = Number.isFinite(unreadCount) && unreadCount > 0;
  const badgeVisible = !!module.badge && !isStatusBadge(module.badge);
  // Moduler som arbetar per projekt (projectTab) öppnar det aktiva projektets flik,
  // annars projektlistan (Mikael F45 2026-10-26, Externa resurser).
  const { currentProject } = useProjectContext() || {};
  const to = module.projectTab && currentProject?.id
    ? `/projects/${currentProject.id}#${module.projectTab}`
    : module.to;
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `kp-nav-item${isActive ? ' kp-nav-item--active' : ''}`}
      aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
    >
      <Icon className="kp-nav-item-icon" size={18} strokeWidth={2} aria-hidden="true" />
      <span className="kp-nav-item-label">
        {module.label}
        {showCount ? (
          <span className="sr-only">{` (${unreadCount} olästa)`}</span>
        ) : null}
      </span>
      {showCount ? (
        <span className="kp-nav-count" aria-hidden="true">{formatCount(unreadCount)}</span>
      ) : null}
      {!showCount && badgeVisible ? <NavItemBadge label={module.badge} /> : null}
      {showStar && onToggleFavorite ? (
        <FavoriteStar
          active={!!isFavorite}
          onToggle={() => onToggleFavorite(module.label)}
          label={module.label}
        />
      ) : null}
    </NavLink>
  );
}
